import { lt, useDialogAction } from '@mews/framework';
import { PaymentPlanPaymentTableRecord, SimpleAmount } from '@mews-commander/data-access';
import { TooltippedIconButton } from '@mews-commander/ui';
import { IconName } from '@optimus-web/icons';
import { DataTestId } from '@mews-commander/enums';
import { WithAccountId } from '@mews-commander/types';
import { useRefundPaymentDialog } from '../Payments/hooks';
import { WithPaymentPlanId } from '../PaymentPlans/types';
import { useCancelFuturePayment } from '../PaymentPlans/queries';
import { CancelFuturePaymentDialog } from './CancelFuturePaymentDialog';

interface Props extends WithPaymentPlanId, WithAccountId {
    hasRefundAction?: boolean;
    hasCancelAction?: boolean;

    simpleAmount: SimpleAmount;
    id: PaymentPlanPaymentTableRecord['id'];
}

export const PaymentPlanDetailsOverviewTableCellActions = ({
    id,

    paymentPlanId,
    simpleAmount,

    accountId,
    hasRefundAction = false,
    hasCancelAction = false,
}: Props) => {
    const { mutateAsync } = useCancelFuturePayment({ paymentPlanId });
    const cancelFuturePaymentAction = useDialogAction(async () => await mutateAsync({ id, amount: simpleAmount }));
    const [createRefundPaymentDialog, toggleCreateRefundPaymentDialog] = useRefundPaymentDialog({
        paymentId: id,
        accountId,
    });

    return (
        <>
            {hasRefundAction && (
                <>
                    <TooltippedIconButton
                        tooltip={lt('PaymentPlanDetailsOverviewTableRefundTooltip')}
                        icon={IconName.Refund}
                        size="small"
                        variant="ghost"
                        onClick={toggleCreateRefundPaymentDialog}
                        type="button"
                        data-test-id={DataTestId.RefundPaymentButton}
                    />
                    {createRefundPaymentDialog()}
                </>
            )}
            {hasCancelAction && (
                <>
                    <TooltippedIconButton
                        tooltip={lt('PaymentPlanDetailsOverviewTableCancelPaymentTooltip')}
                        icon={IconName.CancelSquare}
                        size="small"
                        variant="ghost"
                        onClick={() => cancelFuturePaymentAction.handlers.handleOpen()}
                        type="button"
                        data-test-id={DataTestId.CancelFuturePaymentPlanPaymentButton}
                    />
                    <CancelFuturePaymentDialog actions={cancelFuturePaymentAction} />
                </>
            )}
        </>
    );
};
